export class CollectionScrollPosition {
  constructor() {
    // Last clicked item data
    this.lastClickedItemHrefKey =
      "collectionScrollPosition-lastClickedItemHref";
    this.lastClickedItemHref = sessionStorage.getItem(
      this.lastClickedItemHrefKey,
    );

    // Last visited url data
    this.lastVisitedUrlsKey =
      "collectionScrollPosition-lastVisitedCollectionUrl";
    this.lastVisitedUrls = sessionStorage.getItem(this.lastVisitedUrlsKey);

    this.currentUrl = this.urlToPathName(window.location.href);

    this.init();
  }

  init() {
    if (this.currentUrl.includes("/collections/")) {
      this.handleCollectionTemplate();
    } else if (this.currentUrl.includes("/products/")) {
      this.handleProductTemplate();
    } else {
      this.clearData();
    }
  }

  handleCollectionTemplate() {
    this.checkLastVisistedUrls(this.currentUrl);

    // Disable browser's native scrollRestoration
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    if (this.lastVisitedCollectionUrl === this.currentUrl) {
      this.clearData();
    }

    this.restoreScrollPosition();
    this.captureScrollPosition();
  }

  handleProductTemplate() {
    this.checkLastVisistedUrls(this.currentUrl);

    if (!this.lastClickedItemHref) return;

    // Check to see if current URL matches last clicked item's href value
    // If not, user has navigated away and scroll position data is reset
    if (this.lastClickedItemHref !== this.currentUrl) {
      this.clearData();
    }
  }

  restoreScrollPosition() {
    // Retrieve and restore last position
    if (this.lastClickedItemHref) {
      document
        .querySelector(`a[href="${this.lastClickedItemHref}"]`)
        ?.scrollIntoView({ behavior: "instant" });
    }
  }

  captureScrollPosition() {
    // Capture clicked item
    window.addEventListener("click", (e) => {
      this.lastClickedItemHref = e.target.getAttribute("href");
    });

    // Capture beforeunload event
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem(
        this.lastClickedItemHrefKey,
        this.lastClickedItemHref?.toString(),
      );
    });
  }

  checkLastVisistedUrls(url) {
    const array = this.lastVisitedUrls
      ? [...JSON.parse(this.lastVisitedUrls)]
      : [];
    array.push(url);
    if (array[array.length - 1] === array[array.length - 2]) {
      this.clearData();
    } else {
      sessionStorage.setItem(this.lastVisitedUrlsKey, JSON.stringify(array));
    }
  }

  clearData() {
    sessionStorage.removeItem(this.lastClickedItemHrefKey);
    sessionStorage.removeItem(this.lastVisitedUrlsKey);
    this.lastClickedItemHref = null;
    this.lastVisitedUrls = null;
  }

  urlToPathName(url) {
    const object = new URL(url);
    return object.pathname;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // eslint-disable-next-line no-new
  new CollectionScrollPosition();
});
